import { render, staticRenderFns } from "./mini-statistic.vue?vue&type=template&id=1909f710&"
import script from "./mini-statistic.vue?vue&type=script&lang=js&"
export * from "./mini-statistic.vue?vue&type=script&lang=js&"
import style0 from "./mini-statistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports